import React, { useEffect, useState } from 'react';
import { SkeletonGroup, SkeletonThumbnail } from '@shared/components/Skeleton';
import { LazyScreenProps } from './LazyScreen.types';

export const LazyScreen: React.FC<LazyScreenProps> = props => {
  const { height, width, children, src, aspectRatio, showSkeleton, skeletonGroupOverrides } = props;
  const [loaded, setLoaded] = useState(src === '');

  const handeOnLoad = () => {
    setLoaded(true);
  };

  useEffect(() => {
    if (!src) {
      // if no src, set loaded to true to render children
      setLoaded(true);
    }
    if (!loaded && src) {
      const img = new Image();
      img.onload = handeOnLoad;
      img.src = src;
    }
  }, [loaded, src]);

  return (
    <SkeletonGroup
      isReady={loaded && !showSkeleton}
      overrides={skeletonGroupOverrides}
      placeholder={
        <SkeletonThumbnail
          height={height}
          width={width}
          aspectRatio={aspectRatio}
        />
      }
    >
      {children(loaded)}
    </SkeletonGroup>
  );
};

LazyScreen.displayName = 'LazyScreen';
